export default "__VITE_ASSET__CYnHFrNh__"